import styled from 'styled-components';
import { select } from '../../../core/themev2';
import { getColor } from '../../../core/themev3';

const ContentLayout = styled.div`
  border-radius: 12px;
  background-color: ${({ isSelected }) => (isSelected ? 'white' : 'transparent')};
  height: 64px;
  font-family: 'Hind';
  font-size: 14px;
  font-weight: ${({ isSelected }) => (isSelected ? 600 : 400)};
  line-height: 22px;
  letter-spacing: 0px;
  border: 1px solid ${({ isSelected }) => select(isSelected ? 'grayLight' : 'grayMedium')};
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: ${({ isSelected }) => (isSelected ? 16 : 12)}px;
  cursor: pointer;
  :hover {
    border: 1px solid ${({ isSelected }) => (isSelected ? 'none' : select('grayDark'))};
  }
`;

const SelectedPipe = styled.div`
  background: ${getColor('primary')};
  width: 2px;
  height: 45px;
  border-radius: 2px;
`;

const Label = styled.div`
  margin-top: 4px;
`;

export { ContentLayout, SelectedPipe, Label };
